import React from "react";
import { Leaf, Waves, Zap, Building } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const features = [{
  title: "Recepción IA 24/7",
  description: "Gestión inteligente de llamadas entrantes en todo momento, asegurando que ningún cliente quede sin atención.",
  icon: Zap
}, {
  title: "Videoconferencias",
  description: "Comunicaciones integradas de alta definición para reuniones virtuales fluidas y profesionales desde cualquier lugar.",
  icon: Waves
}, {
  title: "Chat Omnicanal",
  description: "Soporte unificado que integra múltiples canales de mensajería en una sola interfaz para su equipo.",
  icon: Leaf
}, {
  title: "Contact Center",
  description: "Herramientas avanzadas para la gestión de agentes, monitoreo en tiempo real y optimización de la productividad.",
  icon: Building
}, {
  title: "Apps Nativas",
  description: "Acceso total desde iOS, Android, Web y Escritorio para mantener la conectividad en cualquier dispositivo.",
  icon: Zap
}, {
  title: "Soporte Teléfonos IP",
  description: "Integración completa con hardware telefónico estándar para una transición sencilla a la telefonía en la nube.",
  icon: Building
}];
export default function KeyFeaturesGrid() {
  return <section data-section-id="260478" id="key-features-grid" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-12 font-default text-foreground">
          Funcionalidades Clave de Nuestra Plataforma
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-[#EEEEEE] border-border shadow-md hover:shadow-lg transition-shadow h-full flex flex-col rounded-md">
              <CardHeader>
                <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <CardTitle className="font-default text-xl text-foreground font-bold">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-base text-muted-foreground font-sans">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}